<template>
  <div id="Email-body" ref="EmailElement">
    <CCBlockFrame :header="header">
      <div v-if="listdata.length>0" ref="emailContent">
        <div v-for="(item,index) in listdata" :key="index" class="email-main" @click="openWorkFlow(item)">
          <div class="content-left">
            <span v-if="item.subject" class="yuan" />
            {{ item.subject }}
          </div>
          <div class="content-right">
            {{ item.sendPeople }}
          </div>
        </div>

      </div>
      <div v-if="listdata.length==0" style="text-align: center; padding-top: 30px;min-height: 9999px;">
        <img src="images/w-imgs/nomessage.png" style="max-width: 180px"><br>
        <span style="font-size: 15px; color: #dbdbdb">暂无数据</span>
      </div>
    </CCBlockFrame>
  </div>
</template>
<script>
const moment = require('moment')
// import BlockFrame from '@/wapp/common/components/BlockFrame/index'
import { mapGetters } from 'vuex'
export default {
    name: 'Email',
    components: { },
    props: {
        appletData: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            listdata: [],
            pageSize: 6,
            email: '', // 邮箱 账号
            usersetId: '',
            header: {
                title: '内部邮箱',
                more: true,
                icon: this.appletData.icon,
                code: 'email.svg'
            }
        }
    },
    computed: {
        ...mapGetters([
            'routes'
        ])
    },
    created() {
        this.loadInternetList()
    },
    methods: {
        async loadInternetList() {
            const _this = this
            // 进入页面时，先检查是否存在数据，若有，则调用该数据;若无，先初始化.
            await this.$http({
                method: 'GET',
                contentType: 'application/json',
                url: 'mail/userSetup/queryMyMailSetup'
            }).then(response => {
                _this.loading = false
                if (response.code === 'success') {
                    var listAccount = []
                    response.body.listdata.forEach((item) => {
                        if (item.status === 1) { // 邮箱为可用状态（非禁用或删除等）
                            listAccount.push(item)
                        }
                    })
                    this.usersetId = listAccount.length > 0 ? listAccount[0].id : ''
                    if (this.usersetId) {
                        this.getEmail()
                    }
                } else {
                    _this.$toast(response.message)
                }
            }, err => {
                _this.$toast(err)
            })
        },
        async getEmail() {
            const params = {
                pageSize: this.pageSize,
                pageNum: 1
            }
            const res = await this.$app.listdata('/mail/message/listdata?mailBoxType=INBOX&accountType=1&filter=noread&usersetId=' + this.usersetId, params)
            if (res.code === 'success') {
                this.email = '  (' + res.body.email + ' )'
                const listdata = res.body.pageInfo.list
                const length = listdata.length
                if (length < 5 && length > 0) {
                    for (let i = 0; i < 6 - length; i++) {
                        listdata.push({})
                    }
                }
                this.listdata = listdata
            }
            // const length = this.listdata.length
            // if (this.listdata.length < 6) {
            //     for (let i = 0; i < 6 - length; i++) {
            //         this.listdata.push({
            //             subject: '我的而奋斗',
            //             fromAddr: '黄多',
            //             createTime: '10-12 10:12'
            //         })
            //     }
            // }
        },

        cutTime(str) {
            let time = ''
            if (str !== '') {
                time = this.isToday(str) ? moment(str).format('HH:mm') : moment(str).format('MM-DD')
            }
            return time
        },
        isToday(str) {
            const d = new Date(str).setHours(0, 0, 0, 0)
            const today = new Date().setHours(0, 0, 0, 0)
            return d - today === 0
        },
        // 点击行数据
        openWorkFlow(row) {
            if (!row.id) return
            const toPath = this.getMenuCode('email.svg')
            if (toPath && toPath.path) {
                let path
                switch (toPath.meta.level) {
                    case 3:
                        path = toPath.meta.activeMenu || toPath.path
                        break
                    case 4:
                        path = toPath.meta.activeMenu + '/' + toPath.path
                        break
                    default:
                        path = toPath.path
                }
                this.$router.push({ path: path, query: { messageId: row.mailMessageId, mailBoxId: row.mailBoxId }})
            }
        },
        // 递归查询菜单代码
        getMenuCode(code) {
            let toPath
            function findCode(ary) {
                ary.forEach((val) => {
                    if (val.children) {
                        findCode(val.children)
                    }
                    if (!val.children && val.meta && val.meta.code === code) {
                        toPath = val
                        return false
                    }
                })
            }
            findCode(this.routes)
            return toPath
        }
    }
}
</script>
<style lang="scss" scoped>
#Email-body{
        // background-color: #fff;
        // width:100%;
        height:100;
        // border-radius:3px;
        // /deep/ .tablelist{
        //     border-radius:0 0 3px 3px;
        //     .el-table__body{cursor: pointer;}
        // }
     }
     //表格隐藏表头 删除行列线条
// .hideline{
//   /deep/.el-table__row>td{
//     border: none;
//   }
//   /* 去掉上面的线 */
//   /deep/.el-table th.is-leaf{
//     border: none;
//   }
//   /* 去掉最下面的那一条线 */
//   /deep/.el-table::before {
//     height: 0px;
//     width: 0;
//   }
// }
/deep/ .has-gutter tr th{
        background-color: #fff !important;
     }
.email-main{
        cursor: pointer;
        display: flex;
    justify-content: space-between;
    padding: 6px 10px;
    font-size: 14px;
    min-height: 33px;
     &:hover{
        color:#409eff;
        background-color: #eee
      }
    .yuan{
        display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: rgb(51, 51, 51);
    margin-right: 1px;
    position: relative;
    top: -2px;
    opacity: 0.5;
    }
}
.content-left{
   width: 70%;
font-size: 14px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略符号 */
}
.content-right{
    color: gray;
    width: 30%;
    text-align: right;
}
</style>
